import React from "react";
import {selectors as salesSelectors} from "../../../../Ducks/sales";
import {selectors as accountSelectors} from "../../../../Ducks/account";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import GridElement from "../../../Common/GridElement";
import {makeHeader, prepareFilterQuery, prepareSortQuery} from "../../../Utils/gridUtils";
import CapabilityChecker from "../../../Common/CapabilityChecker";
import {Tooltip} from "@mui/material";
import Button from "@mui/material/Button";
import {getSales, rollbackSale} from "../../../../API/sales";
import Swal from "sweetalert2";
import {toast} from "react-toastify";

const SalesList = (props) => {
    const {user, navigate, rollbackSaleCallback} = props;
    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [pageCount, setPageCount] = React.useState(0);
    const [rowsCount, setRowsCount] = React.useState(0);
    const [filters, setFilters] = React.useState([{id: "persons.person_id", value: props.params.id}]);
    const [controlledPageIndex, setControlledPageIndex] = React.useState(0);
    const [refreshGridData, setRefreshGridData] = React.useState(false);
    const columns = user.tableSettings.purchases.columns;
    const cols = columns.map((key) => ({
        column: key,
        accessor: key,
        minWidth: 150,
        Header: makeHeader(key),
        filter: "fuzzyText"
    }));

    const handleRollbackPurchaseClick = (data) => {
        Swal.fire({
            title: `Are you sure want to rollback purchase (${data.purchase_id})?`,
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'Cancel',
        }).then((result) => {
            if (result.isConfirmed) {
                rollbackSale(data.purchase_id).then((res) => {
                    toast.success(res.message);
                    setRefreshGridData(true);
                    rollbackSaleCallback();
                }).catch((error) => {
                    toast.error(error);
                });
            }
        });
    }

    cols.push({
        maxWidth: 50,
        Header: makeHeader("Actions"),
        filter: "fuzzyText",
        Cell: ({row}) => {
            const {rollback_purchase} = row.original;

            return(
            <div>
                {
                    rollback_purchase &&
                    <>
                        <CapabilityChecker capabilities={['can_rollback_purchase']}>
                            <Tooltip title={"Rollback Purchase"} arrow placement='top'>
                                <Button
                                    aria-label={"Rollback Purchase"}
                                    aria-haspopup='true'
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleRollbackPurchaseClick(row.original);
                                    }}
                                    color='primary'
                                    variant='contained'
                                    size='small'
                                    style={{textTransform: "capitalize"}}
                                >
                                    Rollback
                                </Button>
                            </Tooltip>
                        </CapabilityChecker>

                    </>
                }
            </div>
        )}
    });

    const fetchIdRef = React.useRef(0);

    const fetchData = React.useCallback(({pageSize, pageIndex, sortBy, filters, columns}) => {
        // This will get called when the table needs new data
        // You could fetch your data from literally anywhere,
        // even a server. But for this example, we'll just fake it.

        let _columns = columns.map((item) => item.column);
        _columns = _columns.filter((item) => item !== undefined);
        _columns.push("opportunity_id", "jobs.job_id", "persons.person_id");
        // Give this fetch an ID
        const fetchId = ++fetchIdRef.current;
        let query = prepareFilterQuery(filters, columns, "purchases");
        let sort = prepareSortQuery(sortBy, columns);

        setLoading(true);

        getSales({
            results: pageSize,
            columns: _columns,
            offset: pageIndex + 1,
            filter: query,
            sort: sort
        }).then((purchases) => {
            if (fetchId === fetchIdRef.current && purchases) {
                setData(purchases.data.main);
                setPageCount(purchases.data.offset.highest_offset);
                setRowsCount(purchases.data.offset.rows_count);
                setLoading(false);
            }
        }).catch((_error) => {
            setLoading(false);
        });
    }, []);

    const resetFilters = React.useCallback(() => setFilters([]), [setFilters]);

    const handleRowClick = (row) => {
        navigate("/sales/id/" + row.original.purchase_id);
    };

    return (
        <div style={{marginTop: "20px"}}>
            <h2 className='page-title'>Sales</h2>

            <GridElement
                columns={React.useMemo(() => cols, [])}
                data={data}
                fetchData={fetchData}
                loading={loading}
                pageCount={pageCount}
                controlledPageIndex={controlledPageIndex}
                setControlledPageIndex={setControlledPageIndex}
                filters={filters}
                setFilters={setFilters}
                resetFilters={resetFilters}
                rowsCount={rowsCount}
                handleRowClick={handleRowClick}
                initialSortBy={user.tableSettings.purchases.filters.sort}
                hideSelection={true}
                refreshGridData={refreshGridData}
            />
        </div>
    );
};

const mapStateToProps = (state) => ({
    isLoading: salesSelectors.isLoading(state),
    errorMessage: salesSelectors.errorMessage(state),
    user: accountSelectors.user(state),
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
        },
        dispatch
    );

function WithNavigate(props) {
    let navigate = useNavigate();
    let params = useParams();
    return <SalesList {...props} params={params} navigate={navigate}/>;
}

export default connect(mapStateToProps, mapDispatchToProps)(WithNavigate);
